export default {"src":"/_next/static/media/frais-green.b821ff24.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};